import { render, staticRenderFns } from "./ModalCadastraDisciplinaHabilidade.vue?vue&type=template&id=7697de43"
import script from "./ModalCadastraDisciplinaHabilidade.vue?vue&type=script&lang=js"
export * from "./ModalCadastraDisciplinaHabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports